module.exports = __webpack_public_path__ + "static/media/IMG_4557 laundry low front.ae97586c.JPG";